<app-loader *ngIf="loaderIcon | async"></app-loader>

<div class="vendorSearch">
<!-- Filter Section -->
<div class="row mb-2">
    <div class="col-md-3">
        <label>Layout Part</label>
        <select class="form-select form-select-sm" [(ngModel)]="partId" (change)="resetAndLoad()">
            <option value="">All</option>
            <option *ngFor="let part of parts" [value]="part.PartDescription">{{ part.PartDescription }}</option>
        </select>
    </div>

    <div class="col-md-3">
        <label>Search Field</label>
        <select class="form-select form-select-sm" [(ngModel)]="searchField">
            <option value="BoothId">{{'Booth ID' | wordReplace}}</option>
            <option value="CustId">{{'Vendor ID' | wordReplace}}</option>
            <option value="CustName">{{'Vendor Name' | wordReplace}}</option>
        </select>
    </div>

    <div class="col-md-3">
        <label>Search Value</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="searchValue"
            (keyup.enter)="resetAndLoad()">
    </div>
</div>

  <!-- Scrollable Table -->
  <div class="row">
    <div class="col-12">
      <div class="scroll_outer" style="height:400px; overflow-y:auto;" #scrollContainer (scroll)="onScroll()">
        <table class="table table-striped text-center mb-0">
          <thead style="position: sticky; top: 0; z-index: 9; background-color: #fff;">
            <tr>
              <th scope="col" class="text-start" width="25%">{{'Vendor ID' | wordReplace}}</th>
              <th scope="col" class="text-start" width="25%">{{'Vendor Name' | wordReplace}}</th>
              <th scope="col" class="text-start" width="25%">{{'Booth ID' | wordReplace}}</th>
              <th scope="col" class="text-start" width="25%">Part Name</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data" (click)="VendorDetails(item,$event)">
              <td class="text-start">{{ item.MarketVendorId }}</td>
              <td class="text-start">{{ item.VendorName }}</td>
              <td class="text-start">{{ item.BoothNumber }}</td>
              <td class="text-start">{{ item.PartName }}</td>
            </tr>
            <tr *ngIf="data.length == 0">
              <td colspan="4" style="text-align: center;">No records found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
